import styled from "styled-components";

export const CloseIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
